// ─── Auth Domain Types ──────────────────────────────────────────────────────

// ─── Login ──────────────────────────────────────────────────────────────────

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginOtpRequiredResponse {
  requires_otp: true;
  expires_at: string;
  resend_available_at: string;
}

export interface ResendOtpResponse {
  expires_at: string;
  resend_available_at: string;
}

export type LoginResponse = LoginOtpRequiredResponse;

export function isOtpRequired(
  res: LoginResponse
): res is LoginOtpRequiredResponse {
  return 'requires_otp' in res && res.requires_otp === true;
}

// ─── OTP Verification ──────────────────────────────────────────────────────

export interface VerifyLoginOtpRequest {
  email: string;
  otp: string;
}

export interface VerifyLoginOtpResponse {
  token: string;
  user: {
    id: number;
    name: string;
    email: string;
    office?: string | null;
    roles: string[];
    permissions: string[];
  };
}

// ─── Password ───────────────────────────────────────────────────────────────

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  email: string;
  otp: string;
  password: string;
  password_confirmation: string;
}

// ─── Domain ─────────────────────────────────────────────────────────────────

export interface AuthUser {
  id: number;
  email: string;
  name: string;
  phone: string | null;
  avatar: string | null;
  office: string | null;
  roles: string[];
  permissions: string[];
}

export type AuthStatus =
  | 'loading'
  | 'authenticated'
  | 'unauthenticated'
  | 'otp_pending';
